import _default from './Portal';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/addons/Portal/index.js
// module id = 74
// module chunks = 0